import { lazy } from 'react';

export const DesignDryRunModeDemo = lazy(() =>
  import('@/workflows/automation/pages/DryRunModeDemo').then((m) => ({ default: m.DryRunModeDemo }))
);

export const DesignRunwayShapesDemo = lazy(() =>
  import('@/workflows/automation/pages/RunwayShapesDemo').then((m) => ({
    default: m.RunwayShapesDemo,
  }))
);
